import { OrderedProjectRoles, OrderedWorkspaceRoles } from '../../lib/enums';
/**
 * Get the power of the project role of the user.
 * @param user - The user object.
 * @param forbiddenCallback - The forbidden callback.
 * @returns The power of the project role of the user.
 */
export function extractProjectRolePower(user, 
/**
 * forbiddenCallback is used to keep old function behaviour
 */ forbiddenCallback) {
    const reverseOrderedProjectRoles = [...OrderedProjectRoles].reverse();
    const reverseOrderedWorkspaceRoles = [...OrderedWorkspaceRoles].reverse();
    // get most powerful role of user (TODO moving forward we will confirm that user has only one role)
    let role = null;
    let power = -1;
    if (user.base_roles) {
        for (const r of Object.keys(user.base_roles)) {
            const ind = reverseOrderedProjectRoles.indexOf(r);
            if (ind > power) {
                role = r;
                power = ind;
            }
        }
    }
    else if (user.workspace_roles) {
        for (const r of Object.keys(user.workspace_roles)) {
            const ind = reverseOrderedWorkspaceRoles.indexOf(r);
            if (ind > power) {
                role = r;
                power = ind;
            }
        }
    }
    else {
        return -1;
    }
    const ind = reverseOrderedProjectRoles.indexOf(role) !== -1
        ? reverseOrderedProjectRoles.indexOf(role)
        : reverseOrderedWorkspaceRoles.indexOf(role);
    if (ind === -1) {
        forbiddenCallback === null || forbiddenCallback === void 0 ? void 0 : forbiddenCallback();
    }
    return ind;
}
export function hasMinimumRoleAccess(user, minimumRole, 
/**
 * forbiddenCallback is used to keep old function behaviour
 */
forbiddenCallback) {
    const power = extractProjectRolePower(user, forbiddenCallback);
    const reverseOrderedProjectRoles = [...OrderedProjectRoles].reverse();
    const minimumRoleIndex = reverseOrderedProjectRoles.indexOf(minimumRole);
    return power >= minimumRoleIndex;
}
//# sourceMappingURL=data:application/json;base64,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